import {
  SolicitacaoPagamentoFreteAnexoResponseResult,
  FileParameter
} from '../api/lar.logistica.api';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import { ReactElement } from 'react';

/**
 * Função auxiliar para comparar valores considerando tipos
 * @param original
 * @param current
 */
export function compareValues(original: any, current: any): boolean {
  // Se ambos são undefined ou null, são iguais
  if (original == null && current == null) return true;

  // Se um é null/undefined e o outro não, são diferentes
  if ((original == null) !== (current == null)) return false;

  // Para números, converte ambos para string para comparação
  if (typeof original === 'number' || typeof current === 'number') {
    return String(original) === String(current);
  }

  // Para strings, trim e compare
  if (typeof original === 'string' || typeof current === 'string') {
    return String(original).trim() === String(current).trim();
  }

  // Comparação padrão
  return original === current;
}

/**
 * Extrai mensagem de erro mais específica do response da API
 */
export function extractErrorMessage(err: any): string {
  // Prioridade 1: Verifica modelo ApiException
  if (err && err.isApiException === true) {
    if (err.message && typeof err.message === 'string') {
      return err.message;
    }
    if (err.response && typeof err.response === 'string') {
      return err.response;
    }
    if (err.status && typeof err.status === 'number') {
      return `Erro HTTP ${err.status}`;
    }
  }

  // Prioridade 2: Unauthorized
  if (err.message === 'Unauthorized') {
    return 'Não Autorizado, Faça novamente o login';
  }

  // Prioridade 3: Verifica modelo ExceptionDto (message simples)
  if (err.message && typeof err.message === 'string' && !err.errors && !err.detail) {
    return err.message;
  }

  // Prioridade 4: Array de errors (modelo de validação)
  if (err.errors && typeof err.errors === 'object') {
    const errorMessages: string[] = [];

    Object.entries(err.errors).forEach(([field, messages]) => {
      if (Array.isArray(messages)) {
        messages.forEach((message) => {
          errorMessages.push(`${field}: ${message}`);
        });
      } else if (typeof messages === 'string') {
        errorMessages.push(`${field}: ${messages}`);
      }
    });

    if (errorMessages.length > 0) {
      return errorMessages.join('\n');
    }
  }

  // Prioridade 5: Campo detail (modelo RFC 7807)
  if (err.detail && typeof err.detail === 'string') {
    return err.detail;
  }

  // Prioridade 6: Fallback para message ou erro não catalogado
  return err.message || 'Contate o suporte';
}

/**
 * Converte File para FileParameter (usado na API)
 */
export function convertToFileParameter(file: File | null | undefined): FileParameter | undefined {
  if (!file) return undefined;
  return {
    data: file,
    fileName: file.name
  };
}

/**
 * Retorna a quantidade de documentos anexados
 */
export function getAttachedDocumentCount(
  solicitacaoWithAnexos: SolicitacaoPagamentoFreteAnexoResponseResult
): number {
  return solicitacaoWithAnexos?.data?.anexos?.length || 0;
}

/**
 * Verifica se existem documentos anexados
 */
export function hasAttachedDocuments(
  solicitacaoWithAnexos: SolicitacaoPagamentoFreteAnexoResponseResult
): boolean | undefined {
  // console.log('solicitacao', solicitacaoWithAnexos);
  // console.log(
  //   'tem alguma coisa?',
  //   solicitacaoWithAnexos.data?.anexos &&
  //     solicitacaoWithAnexos.data?.anexos &&
  //     solicitacaoWithAnexos.data?.anexos.length > 0
  // );
  return (
    solicitacaoWithAnexos.data?.anexos &&
    solicitacaoWithAnexos.data?.anexos &&
    solicitacaoWithAnexos.data?.anexos.length > 0
  );
}

/**
 * Retorna o ícone apropriado baseado na extensão do arquivo
 */
export function getFileIcon(nomeOriginal?: string): ReactElement {
  if (!nomeOriginal) return <AttachFileIcon />;

  const extension = nomeOriginal.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
      return <PictureAsPdfIcon />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return <ImageIcon />;
    default:
      return <AttachFileIcon />;
  }
}
